import React, { useState } from "react";
import {
  Alert,
  AlertTitle,
  IconButton,
  TextField,
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Divider,
  Grid,
  Stack,
} from "@mui/material";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

import SelectSurvey from '../../../items/select_survey'
import SelectTags from '../../../items/select_tags'
import FailedToLoad from '../../failed_to_load'
import Proggress from '../../../items/progress'
import MessageBar from '../../../items/snackbar'
import NoImg from '../../../_img/img_thumb.png'

import { URL } from '../../../const/general'
import { StackMargin10, BoxSpaceAroundMarginTB30} from '../../../style/box'
import { Image,} from '../../../style/image'

import {
  TypographyTitleLeft,
  TypographyNomal,
  TypographyGray,
  TypographyGraySmall,
  TypographyBold,
} from '../../../style/typography'
import { InputText, } from '../../../style/text_view'
import { GetActiveTags, GetActiveSurveys } from '../../../functions/get_data_swr';

function SendUrl(props) {
  const [title, setTitle] = useState('');
  const [latitude, setLatitude] = useState(0);
  const [longitude, setLongitude] = useState(0);
  const [address, setAddress] = useState('');
  const [overview, setOverview] = useState('');
  const [selectTagList, setSelectTagList] = useState([]);
  const [selectSurveyUUID, setSelectSurveyUUID] = useState('');
  const [createdURL, setCreatedURL] = useState('');
  const [open, setOpen] = useState(false);
  const [snackBarMessage, setSnackBarMessage] = useState('');
  const [openSnackBar, setOpenSnackBar] = useState(false);
  const [snackBarStatus, setSnackBarStatus] = useState('');

  const handleClose = () => {
    setOpen(false);
  };
  const ClickCopy = () => {
    copyTextToClipboard()
    setSnackBarMessage('URLをクリップボードにコピーしました')
    setSnackBarStatus('success')
    setOpenSnackBar(true)
    setOpen(false);
  };
  function copyTextToClipboard() {
    navigator.clipboard.writeText(createdURL)
      .then(function () {
        console.log('Async: Copying to clipboard was successful!');
      }, function (err) {
        console.error('Async: Could not copy text: ', err);
      });
  }
  const CopyButton = () => {
    return (
      <IconButton sx={{
        backgroundColor: '#d3d3d3',
        '&:hover': {
          backgroundColor: '#c0c0c0'
        },
        marginLeft: '10px'
      }}
        onClick={() => ClickCopy()}>
        <ContentCopyIcon />
      </IconButton>
    );
  };

  const CreateURL = (event) => {
    event.preventDefault()
    let url = URL.SPECIFY_UPLOAD + selectSurveyUUID

    if (selectTagList.length > 0) {
      // 選択されているタグUUIDをカンマ区切り文字列で取得
      const tagUUIDList = selectTagList.map((value) => {
        return value.tag_uuid;
      });
      console.log(tagUUIDList)

      const tagUUIDs = tagUUIDList.join(",");
      console.log(tagUUIDs)
      url += '&tag=' + tagUUIDs
    }

    setCreatedURL(url)
    setOpen(true)
  };


  const { activeTags, isActiveTagsLoading, isActiveTagsError } = GetActiveTags();
  const { activeSurvey, isActiveSurveyLoading, isActiveSurveyError } = GetActiveSurveys();
  if (isActiveTagsError) return <FailedToLoad />;
  if (isActiveSurveyError) return <FailedToLoad />;
  if (isActiveTagsLoading) return <Proggress />
  if (isActiveSurveyLoading) return <Proggress />
  console.log(activeTags);
  return (
    <>
      <StackMargin10>
        <TypographyTitleLeft>アップロード依頼URL作成</TypographyTitleLeft>
        <TypographyNomal>調査依頼用のアップロード画面URLを作成します。</TypographyNomal>
        <TypographyNomal>依頼対象の調査およびタグを選択してください。</TypographyNomal>
      </StackMargin10>
      <Divider />
      <StackMargin10 spacing={1}>
        <TypographyBold>調査一覧</TypographyBold>
        {activeSurvey !== null && activeSurvey !== undefined && activeSurvey.length !== 0 ?
          <SelectSurvey
            surveyList={activeSurvey}
            setTitle={setTitle}
            setLatitude={setLatitude}
            setLongitude={setLongitude}
            setOverview={setOverview}
            setSelectSurveyUUID={setSelectSurveyUUID}
            setAddress={setAddress}
          />
          :
          <Alert sx={{ mb: 3 }} severity="warning">
            <AlertTitle>調査が登録されていません</AlertTitle>
            アップロード依頼URLを作成するためには、先に調査情報を登録してください
          </Alert>
        }
      </StackMargin10>
      <Divider />
      {selectSurveyUUID !== undefined &&
        selectSurveyUUID !== null && selectSurveyUUID !== '' &&
        <>
          <Container maxWidth='md'>
            <Grid container 
            sx={{ marginTop: '10px' }} 
            spacing={3}>
              <Grid item xs={12} md={5}>
                <Image
                  src={NoImg}
                />
              </Grid>
              <Grid item xs={12} md={7}>

                <Stack spacing={2}>
                  <InputText type="text" size="small" sx={{ width: '100%' }}
                    value={title}
                    variant="outlined"
                  />
                  <Stack>
                    <TypographyNomal >{address} </TypographyNomal>
                    <TypographyGraySmall >{`${latitude} / ${longitude}`}</TypographyGraySmall>
                  </Stack>
                  <InputText
                    value={overview}
                    multiline
                    minRows={5}
                    placeholder="概要"
                  />
                  {activeTags !== null && activeTags !== undefined && activeTags.length !== 0 ?
                    <SelectTags
                      tagList={activeTags}
                      selectTagList={selectTagList}
                      setSelectTagList={setSelectTagList}
                    />
                    :
                    <>
                      <TypographyGray>災害種別タグ</TypographyGray>
                      <Alert sx={{ mb: 3 }} severity="warning">
                        <AlertTitle>タグが登録されていません</AlertTitle>
                        アップロード依頼URLにタグを指定する場合は、先にタグを登録してください
                      </Alert>
                    </>
                  }
                </Stack>
              </Grid>
            </Grid>
            <BoxSpaceAroundMarginTB30>
              <Button
                type="button"
                variant="contained"
                sx={{
                  width: '50%',
                  backgroundColor: '#2c3e50',
                  '&:hover': {
                    backgroundColor: '#435e7a'
                  }
                }}
                onClick={e => CreateURL(e)}
              >URL生成</Button>
            </BoxSpaceAroundMarginTB30>
          </Container>
        </>
      }
      <Dialog open={open} onClose={handleClose}>
        <DialogContent>
          <DialogContentText style={{ fontWeight: 'bold' }}>
            アップロード画面のURLを生成しました。<br></br>
            以下のURLをコピーしてご利用ください。
          </DialogContentText>
          <TextField sx={{
            mt: 2, minWidth: 500, overflow: 'hidden',
            textOverflow: 'ellipsis'
          }}
            value={createdURL}
            InputProps={{ endAdornment: <CopyButton /> }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>キャンセル</Button>
          <Button onClick={ClickCopy}>コピー</Button>
        </DialogActions>
      </Dialog>
      <MessageBar
        setOpen={setOpenSnackBar}
        open={openSnackBar}
        status={snackBarStatus}
        message={snackBarMessage}
      />
    </>
  )
}

export default SendUrl;